import moment from 'moment'
import { Timestamp } from 'firebase/firestore'

export function getDateStringFromTimestamp(timestamp: Timestamp | null | undefined, pattern: string = 'MM-DD-YYYY, HH:mm'): string {
  if (!timestamp) {
    return ''
  }
  return moment(new Date(timestamp.seconds * 1000)).format(pattern)
}

export function getDateStringFromDate(date: Date | string | null, pattern: string = 'YYYY-MM-DD'): string {
  if (!date) {
    return ''
  }
  return moment(date).format(pattern)
}

export function getDateString(dateString: string = '', pattern: string = 'YYYY-MM-DD'): string {
  const date = dateString ? new Date(dateString + 'T23:59:59') : new Date()
  return moment(date).format(pattern)
}

export function getCurDateString(pattern: string = 'YYYYMMDD_HHmmss') {
  return moment(new Date()).format(pattern)
}

export function zeroPad(value: number, length: number = 2): string {
  return value.toString().padStart(length, '0')
}

export function getQuantityFormat(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return ''
  }
  return getDecimalFormat(value / 100)
}

export function getDecimalFormat(value: number | null | undefined, forceFloat: boolean = false): string {
  if (value === null || value === undefined) {
    return ''
  }
  
  // Proper way to check if number has decimal places
  const isFloat = forceFloat || !Number.isInteger(value)
  const options: Intl.NumberFormatOptions = {
    minimumFractionDigits: isFloat ? 2 : 0,
    maximumFractionDigits: isFloat ? 2 : 0,
  }
  return Number(value).toLocaleString('en', options)
}

export function getRoundValue(value: number): number {
  return Math.round((value + Number.EPSILON) * 100) / 100
}

export function getPriceFormat(amount: number | null | undefined, currency = 'USD'): string {
  if (amount === null || amount === undefined) {
    return ''
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2
  }).format(amount / 100)
}

export function getUserName(firstName: string, lastName: string): string {
  return `${firstName} ${lastName}`
}

export function getUnitString(category: string): string {
  switch (category) {
    case 'Flower': return 'Gram'
    case 'Vapes': return 'Vape'
    case 'Edibles': return 'Gummy'
    default: return ''
  }
}

export function getSortItem(obj: any, sortBy: string): any {
  return obj[sortBy]
}

export function setKeywordSpan(text: string, keyword: string): string {
  if (!keyword) return text
  const escaped = keyword.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') // escape regex
  const regex = new RegExp(`(${escaped})`, 'gi')
  return text.replace(regex, '<span class="text-orange-600 font-semibold">$1</span>')
}